import { regionsToOption, TOption } from '_shared';
import { FormSelectField, FormTextField } from 'components/form';
import { Column } from 'components/ui-kit';
import { useFormikContext } from 'formik';
import { useRegions } from 'hooks';
import { useState, useEffect } from 'react';
import { TOfferForm } from '../../../offer-form.types';

type TRegionAndCityRowProps = {
  isForeignCountry: boolean;
};

export const RegionAndCityRow = ({
  isForeignCountry,
}: TRegionAndCityRowProps): JSX.Element => {
  const { values } = useFormikContext<TOfferForm>();
  const [regions, setRegions] = useState<Array<TOption>>([]);
  const regionsData = useRegions();

  useEffect(() => {
    setRegions(regionsToOption(regionsData));
  }, [regionsData]);

  return (
    <>
      {!isForeignCountry && (
        <Column span={{ s: 12, l: 6 }}>
          <FormSelectField
            isAutocomplete={false}
            label="Область / Край *"
            name="state"
            options={regions}
            initValue={{
              label: values.state,
              value: values.state,
            }}
          />
        </Column>
      )}
      <Column span={{ s: 12, l: 6 }}>
        {!isForeignCountry && (
          <FormTextField
            isDisabled={!values.state}
            label="Город *"
            name="city"
            placeholder="Укажите населённый пункт"
          />
        )}
        {isForeignCountry && <FormTextField name="city" label="Город *" />}
      </Column>
    </>
  );
};
